<template>
  <el-tree :data="data" :highlight-current="true" :props="treeProps" node-key="SerialCodeId">
    <span class="custom-tree-node" slot-scope="{data}" @click="onSelect(data)">
      <span>{{ data.SerialType }}编码</span>
    </span>
  </el-tree>
</template>
<script>
export default {
  data() {
    return {
      data: [],
      api: require("@/api/sy/serialCode").default,
      treeProps: {
        children: "children",
        label: "Name",
      },
    };
  },
  methods: {
    init() {
      this.api.list({}).then((res) => {
        this.data = res.Data;
        if (this.data.length > 0) {
          this.onSelect(this.data[0]);
        }
        // this.source = res.Data.map((x) => {
        //   var check = notIds.some((c) => c == x.DistrictId || c == x.Pid);
        //   return { ...x, check: check };
        // });
        // this.data = this.$commonJs.toTreeData(this.source, "DistrictId");
      });
    },
    onSelect(data) {
      this.$emit("select", data);
    },
  },
};
</script>
<style lang="scss" scoped>
.custom-tree-node {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  width: 100%;
  .btn-box {
    float: right;
    margin-right: 10px;
    .btn {
      font-size: 22px;
      width: 50px;
      padding: 0 !important;
      height: 24px;
      text-align: center;
      transform: translateY(4px);
    }
  }
}
</style>